import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'

import BlogBlurb from '../components/BlogBlurb'
import Box from '../styled/Box'
import CoreValues from '../components/CoreValues'
import Layout from '../components/Layout'
import Lead from '../components/Lead'
import ProjectsBlurb from '../components/ProjectsBlurb'
import SEO from '../components/SEO'
import WorkBlurb from '../components/WorkBlurb'

function IndexPage(props = {}) {
  const postData = get(props, 'data.allMdx.edges[0].node')
  return (
    <Layout>
      <SEO title="Drew Barontini" />
      <Lead />
      <Box pb="xl">
        <CoreValues />
      </Box>
      <Box pb="xxl">
        <BlogBlurb post={postData} />
      </Box>
      <Box pb="xl">
        <WorkBlurb />
      </Box>
      <Box pb="xl">
        <ProjectsBlurb />
      </Box>
    </Layout>
  )
}

export const pageQuery = graphql`
  query {
    allMdx(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { draft: { ne: true } } }
      limit: 1
    ) {
      edges {
        node {
          excerpt
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
          }
          fields {
            slug
          }
        }
      }
    }
  }
`

export default IndexPage
